import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { BasicInput } from '@dev/ee-components';
import { PaidNewsletterCreatorStatus } from '@/store/paidNewsletterCreator/types';
import { getPaidNewsletterCreatorStore, ModifyEmailTemplate } from '@/store/paidNewsletterCreator/actions';
import { CustomizeSubject } from './components/CustomizeSubject';

export const EmailSubject = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { paidNewsletterObject, postPurchaseTemplatePayload, status } = useSelector(getPaidNewsletterCreatorStore);

    const subject = postPurchaseTemplatePayload?.subject ?? paidNewsletterObject.PostPurchaseTemplate?.Body?.Subject ?? t('paidnewsletterpostpurchasedefaultsubject');
    const subjectHasError = postPurchaseTemplatePayload && postPurchaseTemplatePayload?.subject === '';

    const handleSubjectChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        dispatch(ModifyEmailTemplate({ subject: event.target.value }));
    };

    return (
        <div>
            <BasicInput
                id="paid-newsletter-post-purchase-subject"
                label={t('subject')}
                value={subject}
                onChange={handleSubjectChange}
                endIcon={<CustomizeSubject subject={subject} />}
                style={{ paddingRight: 140 }}
                error={subjectHasError}
                errorMessage={t('thisfieldisrequired')}
                readOnly={status === PaidNewsletterCreatorStatus.SAVING}
            />
        </div>
    );
};
